import { Metadata } from "src/utils/post";
import { PostCard } from "src/components/blog/PostCard";
import { SwiperCards } from "src/components/reusable/SwiperCards";
import { cn } from "src/utils/style";

export function Collection({
  formattedTitles,
  posts,
  selectedTags,
}: {
  posts: Metadata[];
  selectedTags: string[];
  formattedTitles?: (string | undefined)[];
}) {
  return (
    <SwiperCards
      rounded
      slides={posts.map((metadata, index) => (
        <PostCard
          metadata={metadata}
          key={index}
          className="border-primary"
          selectedTags={selectedTags}
          formattedTitle={formattedTitles?.[index]}
        />
      ))}
      className={cn(
        "max-w-[250px]",
        "sm:max-w-[400px]",
        "overflow-hidden sm:overflow-visible",
        "px-8 sm:p-0",
        "overflow-hidden",
      )}
    />
  );
}
